import { useEffect } from "react";
import { pushDataLayer } from "./pageMeta";

/**
 * Sitewide document-level listener that fires a `whatsapp_click` dataLayer
 * event whenever a link pointing at wa.me / api.whatsapp.com is clicked.
 * Attached once at the app root — no per-link wiring required.
 */
export function useWhatsAppTracking() {
  useEffect(() => {
    const onClick = (e) => {
      const link = e.target instanceof Element ? e.target.closest("a[href]") : null;
      if (!link) return;
      const href = link.getAttribute("href") || "";
      if (/^(https?:)?\/\/(wa\.me|api\.whatsapp\.com)\//i.test(href) || href.startsWith("whatsapp:")) {
        pushDataLayer("whatsapp_click", {
          link_url: href,
          link_location: window.location.pathname,
        });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
}
